<template>
  <div
    class="wizard-footer"
    :style="{ backgroundColor: color }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WizardFooter',
  props: {
    color: { type: String, default: '' },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  a {
    color: @text-brand;
  };
  .wizard-footer {
    color: @text-lighter;
  }

</style>
